/**
 * @file ProductGuidelines.tsx
 * @module app/modals/ProductGuidelines
 * @description Renders the ProductGuidelines modal dialog for confirming actions, capturing workflow input, and reporting outcomes to its parent screen.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.3.0
 */

import { Col, Modal } from "react-bootstrap";
// Media <<
import CrossSvg from "../../_admin/assets/media/close.png";
import GImg1 from "../../_admin/assets/media/product/guidelines/img1.png";
import GImg2 from "../../_admin/assets/media/product/guidelines/img2.png";
import GImg3 from "../../_admin/assets/media/product/guidelines/img3.png";

function ProductGuidelines(props: any) {
  return (
    <>
      <Modal
        show={props.show}
        onHide={props.onHide}
        // contentClassName="py-md-5"
        dialogClassName="modal-dialog-centered min-w-lg-794px"
        className="border-r10px"
      >
        <Modal.Header className="border-bottom-0 pb-6 pt-lg-10">
          <img
            className="close-inner-top-2"
            width={40}
            height={40}
            src={CrossSvg}
            alt="closebutton"
            onClick={props.onHide}
          />
          <Modal.Title className="mx-auto fs-26 fw-700">
            Product image guidelines
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="pt-0">
          <div className="text-center px-lg-5 mb-6">
            <p className="fs-18 fw-500">
              Please follow image guidelines to reduce the quality check
              faliures
            </p>
          </div>

          <div className="details-pending green-tick-li">
            <ul className="ps-0 mb-0">
              <li className="details list-group-item">
                Use clear colour images with minimum resolution of 1000px X
                1000px
              </li>
              <li className="details list-group-item">
                Upload authentic product photos taken in bright lighting.
              </li>
              <li className="details list-group-item">
                Check out the sample images to ensure you provide the correct
                image view. e.g. First Image has to be the Front view.
              </li>
            </ul>
          </div>

          <div className="row">
            <div className="col-12 my-6 mb-4">
              <h6 className="fs-20 fw-bolder">Sample images</h6>
            </div>
            <Col lg={3} md={4} xs={6} className="mb-5">
              <img
                className="img-fluid object-fit-contain"
                src={GImg1}
                alt=""
              />
            </Col>
            <Col lg={3} md={4} xs={6} className="mb-5">
              <img
                className="img-fluid object-fit-contain"
                src={GImg2}
                alt=""
              />
            </Col>
            <Col lg={3} md={4} xs={6} className="mb-5">
              <img
                className="img-fluid object-fit-contain"
                src={GImg3}
                alt=""
              />
            </Col>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

// export {kycRejected}
export default ProductGuidelines;
